import React from "react";

// components
import Typography from "../../components/Typography/Typography";

import Converter from "persian-date-converter";

// styled components
import {
  CardTitle,
  Column,
  ContactStyle,
  Container,
  Content,
  ContentContact,
  ContentSeller,
  FactorStyle,
  HeaderFactor,
  InfoStyle,
  MainContentContact,
  NumberFactor,
  Row,
  Table,
  Title,
  Tr,
  Wrapper,
} from "./factorStyle";
import { percentPrice } from "../../utils/percentPrice";
import { separate } from "../../utils/separate";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";

const FactorParent = ({
  children,
  PreInvoice,
  UserSubmitted,
  addresses,
  list_order_offlines,
  PriceDebt,
  factor_status_payments,
}) => {
  const _date = new Converter();
  const result = list_order_offlines?.map((item) =>
    percentPrice(
      item?.GeneralPriceProductsOrder,
      item?.NumberSeller,
      item?.Discount
    )
  );

  const mandeHesab = PreInvoice?.PriceAll - PreInvoice?.DepositAll;
  const res = mandeHesab - PriceDebt;
  const totalPrice = result?.reduce(
    (previousValue, currentValue) => previousValue + currentValue,
    0
  );
  return (
    <Container>
      <FactorStyle>
        <HeaderFactor>
          <Typography align="center" className="w-100" size="14px">
            {PreInvoice?.StatusOrderOffline === "Active"
              ? "(فاکتور)"
              : "(پیش فاکتور)"}
          </Typography>
          <Typography
            align="center"
            className="w-100"
            size="14px"
            weight="bold"
          >
            به سود
          </Typography>
        </HeaderFactor>
        <ContactStyle>
          <ContentContact>
            <Wrapper>
              <Title>مشخصات فاکتور</Title>
            </Wrapper>
            <MainContentContact>
              <Typography size="14px">
                توسط :{" "}
                {`${UserSubmitted?.FirstName} ${UserSubmitted?.LastName}`}
              </Typography>
              <NumberFactor>
                <Typography size="14px">
                  تاریخ : {_date.convert(PreInvoice?.created_at, "fa")}
                </Typography>
                <Column>
                  <Typography size="16px">شماره فاکتور</Typography>
                  <Typography size="16px">
                    {PreInvoice?.IdShowUserOrderOffline}
                  </Typography>
                </Column>
                <Typography></Typography>
              </NumberFactor>
            </MainContentContact>
          </ContentContact>
          <ContentSeller>
            <Wrapper>
              <Title>مشخصات خریدار</Title>
            </Wrapper>
            <InfoStyle>
              <Row>
                <Typography size="14px">
                  عنوان : آقای / خانم{" "}
                  {`${PreInvoice?.FirstName} ${PreInvoice?.LastName}`}
                </Typography>
                <Typography size="14px">
                  کد : {PreInvoice?.IdOrderOffline}
                </Typography>
              </Row>
              <Typography size="14px">
                تلفن های تماس : ({PreInvoice?.Phone})
              </Typography>
              <Typography size="14px">آدرس : {addresses?.Address}</Typography>
            </InfoStyle>
            <Table>
              <Tr>
                <th>ردیف</th>
                <th>کد کالا</th>
                <th>مشخصات کالا</th>
                <th>مقدار</th>
                <th>واحد</th>
                <th>فی</th>
                <th>مبلغ کل</th>
                <th>تخفیف</th>
                <th>مبلغ خالص</th>
              </Tr>
              {children}
              <Tr className="text-right">
                <td className="desc text-right" colSpan="9">
                  توضیحات : {PreInvoice?.DescriptionOrderOffline}
                </td>
              </Tr>

              <Tr>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff">مبلغ کل فاکتور</td>
                <td className="diff">{separate(PreInvoice?.PriceAll)}</td>
              </Tr>
              <Tr>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff"></td>
                <td className="diff">تخفیف</td>
                <td className="diff">{list_order_offlines[0]?.Discount}</td>
              </Tr>
              <Tr>
                <td className="demo"></td>
                <td className="demo"></td>
                <td className="demo"></td>
                <td className="demo"></td>
                <td className="demo"></td>
                <td className="demo"></td>
                <td className="demo"></td>
                <td className="demo">قابل پرداخت</td>
                <td className="demo">{separate(totalPrice)}</td>
              </Tr>
            </Table>
            <Content top>
              <Typography size="14px">
                مانده حساب شما تا قبل از این فاکتور در تاریخ(
                {_date.convert(PreInvoice?.created_at, "fa")})، مبلغ{" "}
                {separate(PriceDebt)}{" "}
                {PriceDebt === 0
                  ? "بی حساب"
                  : PriceDebt > 0
                  ? "بدهکار"
                  : PriceDebt < 0
                  ? "بستانکار"
                  : null}{" "}
                می باشید.
              </Typography>
              <Typography size="14px">
                مانده حساب نهایی شما مبلغ {separate(res)} تومان بستانکار می باشد
              </Typography>
            </Content>
            <Content>
              <Typography size="14px">
                {" "}
                نحوه دریافت :
                <br />
                {factor_status_payments && (
                  <Typography>
                    {factor_status_payments?.KindPayments} :{" "}
                    {separate(factor_status_payments?.PricePayments)} تومان
                  </Typography>
                )}
              </Typography>
            </Content>
            <Content>
              <CardTitle>
                <Typography size="14px">امضای تحویل گیرنده</Typography>
                <Typography size="14px">امضای خریدار</Typography>
                <Typography size="14px">امضای فروشنده</Typography>
              </CardTitle>
            </Content>
            <Content bottom>
              <Typography align="left" size="14px">
                تاریخ چاپ : {MiladiToShamsi(PreInvoice[0]?.created_at)}
              </Typography>
            </Content>
          </ContentSeller>
        </ContactStyle>
        {/* <Description>
          <Typography size="14px">توضیحات : </Typography>
        </Description> */}
      </FactorStyle>
    </Container>
  );
};

export default FactorParent;
